'use strict'

// One workspace-app launcher card for the home "apps" grid: a design-system
// Icon on top + title + a one-line caption, routing into the app on click.
//
// Flat treatment — no card border and no accent colours (per the home
// sections' borderless look); icons render in the neutral title colour. The
// per-app `color` in HOME_APPS is intentionally unused here (kept so accents
// can be re-enabled without re-deriving the palette).
//
// Per-card state (fed by main.js's HOME_APPS via childrenAs: 'state'):
//   { title, caption, icon, route }
export const AppCard = {
  tag: 'button',
  type: 'button',
  flow: 'y',
  gap: 'Z',
  round: 'radiusControl',
  padding: 'B',
  textAlign: 'left',
  cursor: 'pointer',
  color: 'title',
  background: 'transparent',
  transition: '160ms defaultBezier background',
  ':hover': { background: 'hover' },

  onClick: (e, el, s) => {
    if (s.route) el.router(s.route, el.getRoot())
  },

  // Bare icon (no tile wrapper, default size) — inherits the card's neutral
  // `color: 'title'` via the Icon's `fill: currentColor`.
  Icon: {
    icon: (el, s) => s.icon
  },

  AppName: {
    tag: 'span',
    fontSize: 'A',
    fontWeight: '700',
    color: 'title',
    text: (el, s) => s.title
  },

  AppCaption: {
    tag: 'p',
    margin: '0',
    fontSize: 'Y',
    lineHeight: '1.4',
    color: 'caption',
    text: (el, s) => s.caption
  }
}
